import React from 'react';
interface CTABlockProps {
  href?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
// Add type for fbq
declare global {
  interface Window {
    fbq: any;
  }
}
export function CTABlock({
  href = '#cart',
  children,
  className = '',
  onClick
}: CTABlockProps) {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
    if (onClick) onClick();
  };
  return <a href={href} onClick={handleClick} className={`inline-block bg-gold-500 hover:bg-gold-400 text-forest-900 font-bold py-4 px-8 rounded-full text-center transition-colors animate-pulse-gold shadow-lg ${className}`} data-id="element-15">
      {children}
    </a>;
}